import { Grid } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import Button from "../../CustomButtons/Button";
import { Archive, Pause, PlayArrow, Refresh } from "@mui/icons-material";
import AuthenticationWrapper from "../../../auth/AuthenticationWrapper";
import TranslationWrapper from "../../TranslationWrapper/TranslationWrapper";
import Pagination from "../Pagination";
import React from "react";

function PaginationV2({
  showRefresh,
  reloadDataFromServer,
  showAutoRenew,
  isAutoRenewing,
  deleteKey,
  setIsAutoRenewing,
  showArchive,
  setShowArchive,
  paginationData,
  page,
  rowsPerPage,
  rowsPerPageOptions,
  handleChangeRowsPerPage,
  handleChangePage,
}) {
  return (
    <Grid container style={{ padding: 16 }} wrap={"nowrap"}>
      <Grid item md={3} xs={12}>
        {showRefresh ? (
          <Tooltip placement={"bottom"} title={"Refresh table"}>
            <Button color={"primary"} justIcon onClick={reloadDataFromServer} size={"sm"}>
              <Refresh />
            </Button>
          </Tooltip>
        ) : null}

        {showAutoRenew ? (
          <Tooltip
            placement={"bottom"}
            title={isAutoRenewing ? "Pauze automatisch vernieuwen" : "Automatisch vernieuwen"}
          >
            <Button
              color={"primary"}
              justIcon
              onClick={() => {
                setIsAutoRenewing((val) => !val);
              }}
              size={"sm"}
            >
              {isAutoRenewing ? <Pause /> : <PlayArrow />}
            </Button>
          </Tooltip>
        ) : null}

        {deleteKey ? (
          <AuthenticationWrapper permissionKey={deleteKey}>
            <Tooltip
              placement={"bottom"}
              title={
                showArchive ? (
                  <TranslationWrapper tDefault={"Laat normale items zien"} tKey={"global.jamezz.table.hideArchive"} />
                ) : (
                  <TranslationWrapper tDefault={"Laat archief zien"} tKey={"global.jamezz.table.showArchive"} />
                )
              }
            >
              <Button
                color={showArchive ? "success" : "primary"}
                justIcon
                onClick={() => setShowArchive((val) => !val)}
                size={"sm"}
              >
                <Archive />
              </Button>
            </Tooltip>
          </AuthenticationWrapper>
        ) : null}
      </Grid>
      <Pagination
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        page={page}
        paginationData={paginationData}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        totalItems={paginationData?.total ?? 0}
        totalPages={paginationData?.last_page ?? 1}
      />
    </Grid>
  );
}

export default PaginationV2;
